document.addEventListener('DOMContentLoaded', function () {
  initRevealOnScroll();
  initFaqAcordeon();
  initContadores();
  initTilt();
});

function initTilt() {
  if (window.matchMedia('(hover: none)').matches) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  var els = document.querySelectorAll('.sm-tilt');
  els.forEach(function (el) {
    el.addEventListener('mousemove', function (e) {
      var rect = el.getBoundingClientRect();
      var x = (e.clientX - rect.left) / rect.width - 0.5;
      var y = (e.clientY - rect.top) / rect.height - 0.5;
      el.style.transform = 'perspective(900px) rotateY(' + (x * 8) + 'deg) rotateX(' + (y * -8) + 'deg) translateY(-4px)';
    });
    el.addEventListener('mouseleave', function () {
      el.style.transform = 'perspective(900px) rotateY(0deg) rotateX(0deg) translateY(0)';
    });
  });
}

function initRevealOnScroll() {
  var els = document.querySelectorAll('.sm-reveal');
  if (!els.length) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    els.forEach(function (el) { el.classList.add('sm-visible'); });
    return;
  }
  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('sm-visible');
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.15, rootMargin: '0px 0px -60px 0px' });
  els.forEach(function (el) { observer.observe(el); });
}

function initFaqAcordeon() {
  var grupos = document.querySelectorAll('.sm-faq-lista');
  if (!grupos.length) return;
  grupos.forEach(function (grupo) {
    var items = grupo.querySelectorAll('.sm-faq-item');
    function cerrar(item) {
      item.classList.remove('sm-faq-abierta');
      var respuesta = item.querySelector('.sm-faq-respuesta');
      if (respuesta) respuesta.style.maxHeight = '0px';
    }
    function abrir(item) {
      item.classList.add('sm-faq-abierta');
      var respuesta = item.querySelector('.sm-faq-respuesta');
      if (respuesta) respuesta.style.maxHeight = respuesta.scrollHeight + 'px';
    }
    items.forEach(function (item) {
      var pregunta = item.querySelector('.sm-faq-pregunta');
      if (!pregunta) return;
      pregunta.addEventListener('click', function () {
        var abierta = item.classList.contains('sm-faq-abierta');
        items.forEach(cerrar);
        if (!abierta) abrir(item);
      });
    });
  });
}

function initContadores() {
  var els = document.querySelectorAll('.sm-contador');
  if (!els.length) return;
  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      var el = entry.target;
      observer.unobserve(el);
      var fin = parseFloat(el.getAttribute('data-fin') || '0');
      var decimales = (el.getAttribute('data-fin') || '').includes('.') ? 1 : 0;
      var duracion = 1400;
      var inicio = null;
      function paso(ts) {
        if (!inicio) inicio = ts;
        var progreso = Math.min((ts - inicio) / duracion, 1);
        var valor = fin * progreso;
        el.textContent = valor.toFixed(decimales);
        if (progreso < 1) requestAnimationFrame(paso);
        else el.textContent = fin.toFixed(decimales);
      }
      requestAnimationFrame(paso);
    });
  }, { threshold: 0.4 });
  els.forEach(function (el) { observer.observe(el); });
}
